import type { IncomingHttpHeaders } from 'http';
import type { AxiosResponse } from 'axios';
import { donedealGateway } from '../api/api-utils/commonApiUtils';
import type { GreenlightRegistrationLookupResponse } from '../api/historyCheck.typed';

async function greenlightRegistrationLookup(
  reg: string,
  headers: IncomingHttpHeaders,
): Promise<AxiosResponse<GreenlightRegistrationLookupResponse>> {
  return await donedealGateway.get(
    `/ddapi/v1/vehicle/available-report/${reg}`,
    { headers },
  );
}

export { greenlightRegistrationLookup };
